import { useEffect, useState } from 'react'

export const hideChatWithTranscriptNewBadgeLocalStorageKey =
  'hideChatWithTranscriptNewBadgeLocalStorageKey'

export function ChatWithTranscriptTab() {
  const [showNewBadge, setShowNewBadge] = useState(false)

  useEffect(() => {
    const localStorageValue = window.localStorage.getItem(
      hideChatWithTranscriptNewBadgeLocalStorageKey
    )

    if (!localStorageValue || localStorageValue === 'false') {
      setShowNewBadge(true)
    }
  }, [])

  return (
    <div className="relative">
      Chat with video
      {showNewBadge && (
        <span className="absolute -top-4 -right-7 bg-blue-500 text-white text-xs px-1.5 py-0.5 rounded-full">
          New
        </span>
      )}
    </div>
  )
}
